// src/components/Section.jsx
import React from "react";
export default function Section({ id, title, eyebrow, subtitle, children, tight=false }) {
  return (
    <section id={id} className={tight ? "section-tight" : "section"}>
      <div className="container-tight">
        {eyebrow && <p className="badge">{eyebrow}</p>}
        {title && <h2 className="h2">{title}</h2>}
        {subtitle && <p className="muted" style={{marginBottom:16,maxWidth:720}}>{subtitle}</p>}
        {children}
      </div>
    </section>
  );
}
